import { render, staticRenderFns } from "./RentDetail.vue?vue&type=template&id=535334fe&scoped=true"
import script from "./RentDetail.vue?vue&type=script&lang=js"
export * from "./RentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535334fe",
  null
  
)

export default component.exports